module.exports = __webpack_public_path__ + "img/carNo.cf5eb1a5.png";